import React from 'react'
import { Box, makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Carousel from 'react-material-ui-carousel'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import isMobile from './utils/is-mobile'
import Noa1 from './images/noa/noa-1.jpg'
import Noa2 from './images/noa/noa-2.jpg'
import Noa3 from './images/noa/noa-3.jpg'
import Noa4 from './images/noa/noa-4.jpg'
import Noa5 from './images/noa/noa-5.jpg'
import Noa6 from './images/noa/noa-6.jpg'
import Noa7 from './images/noa/noa-7.jpg'
import Noa8 from './images/noa/noa-8.jpg'
import Noa9 from './images/noa/noa-9.jpg'
import Noa10 from './images/noa/noa-10.jpg'
import Noa11 from './images/noa/noa-11.jpg'
import Noa12 from './images/noa/noa-12.jpg'
import Noa13 from './images/noa/noa-13.jpg'
import Noa14 from './images/noa/noa-14.jpg'
import Noa15 from './images/noa/noa-15.jpg'
import Noa16 from './images/noa/noa-16.jpg'
import Noa17 from './images/noa/noa-17.jpg'
import Noa18 from './images/noa/noa-18.jpg'
import Noa19 from './images/noa/noa-19.jpg'
import Noa20 from './images/noa/noa-20.jpg'
import Noa21 from './images/noa/noa-21.jpg'
import Noa22 from './images/noa/noa-22.jpg'
import Noa23 from './images/noa/noa-23.jpg'
import Noa24 from './images/noa/noa-24.jpg'
import Noa25 from './images/noa/noa-25.jpg'
import Noa26 from './images/noa/noa-26.jpg'
import Noa27 from './images/noa/noa-27.jpg'
import Noa28 from './images/noa/noa-28.jpg'
import Noa29 from './images/noa/noa-29.jpg'
import Noa30 from './images/noa/noa-30.jpg'
import Noa31 from './images/noa/noa-31.jpg'
import Noa32 from './images/noa/noa-32.jpg'
import Noa33 from './images/noa/noa-33.jpg'
import Noa34 from './images/noa/noa-34.jpg'
import Noa35 from './images/noa/noa-35.jpg'
import Noa36 from './images/noa/noa-36.jpg'
import Noa37 from './images/noa/noa-37.jpg'
import Noa38 from './images/noa/noa-38.jpg'
import Noa39 from './images/noa/noa-39.jpg'
import Noa40 from './images/noa/noa-40.jpg'
import Noa41 from './images/noa/noa-41.jpg'
import Noa42 from './images/noa/noa-42.jpg'
import Noa43 from './images/noa/noa-43.jpg'
import Noa44 from './images/noa/noa-44.jpg'
import Noa45 from './images/noa/noa-45.jpg'
import Noa46 from './images/noa/noa-46.jpg'
import Noa47 from './images/noa/noa-47.jpg'
import Noa48 from './images/noa/noa-48.jpg'
import Noa49 from './images/noa/noa-49.jpg'
import Noa50 from './images/noa/noa-50.jpg'

const useStyles = isMobile()
  ? makeStyles({
      carouselContainer: {
        margin: 30,
        width: '50%',
        height: 600,
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
      },
      imageContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
      },
      container: {
        display: 'flex',
        flex: 1
      },
      description: {
        marginTop: 10,
        width: '90%',
        alignSelf: 'center',
        display: 'inline-block'
      },
      textContainer: {
        textAlign: 'center'
      }
    })
  : makeStyles({
      carouselContainer: {
        margin: 30,
        width: '50%',
        height: 600,
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
      },
      imageContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
      },
      container: {
        display: 'flex',
        flex: 1
      },
      description: {
        marginTop: 20,
        width: '60%',
        alignSelf: 'center',
        display: 'inline-block'
      },
      textContainer: {
        textAlign: 'center'
      }
    })

const noaPictures = [
  Noa1,
  Noa2,
  Noa3,
  Noa4,
  Noa5,
  Noa6,
  Noa7,
  Noa8,
  Noa9,
  Noa10,
  Noa11,
  Noa12,
  Noa13,
  Noa14,
  Noa15,
  Noa16,
  Noa17,
  Noa18,
  Noa19,
  Noa20,
  Noa21,
  Noa22,
  Noa23,
  Noa24,
  Noa25,
  Noa26,
  Noa27,
  Noa28,
  Noa29,
  Noa30,
  Noa31,
  Noa32,
  Noa33,
  Noa34,
  Noa35,
  Noa36,
  Noa37,
  Noa38,
  Noa39,
  Noa40,
  Noa41,
  Noa42,
  Noa43,
  Noa44,
  Noa45,
  Noa46,
  Noa47,
  Noa48,
  Noa49,
  Noa50
]

const Noa: React.FC = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <>
      <Box className={classes.container}>
        <Box className={classes.carouselContainer}>
          <Carousel
            PrevIcon={<NavigateBeforeIcon />}
            NextIcon={<NavigateNextIcon />}
            autoPlay={false}
          >
            {noaPictures.map((item, i) => (
              <Box className={classes.imageContainer} key={i}>
                <img src={item} alt='noa' height={600} />
              </Box>
            ))}
          </Carousel>
        </Box>
      </Box>
      <Box className={classes.textContainer}>
        <Box className={classes.description}>{t('noaDescription')}</Box>
      </Box>
    </>
  )
}

export default Noa
